import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import classes from './PositionPage.module.css';
import PositionCard from './PositionCard';
import { ReactComponent as NoPosition } from '../../icons/NoPositionIcon.svg';
import AddNewPositionButton from '../EmployerDashboard/AddNewPositionButton';
import Spinner from '../Spinner/Spinner';
import { useLoadPositionsQuery } from '../../store/modules/companies';

const PositionPage: FC = () => {
  const [t] = useTranslation('global');
  const { data: position = [], isLoading } = useLoadPositionsQuery({});

  return isLoading ? (
    <div className="w-full flex" data-testid="spinner">
      <Spinner />
    </div>
  ) : (
    <div
      className="container px-4 pb-4 md:px-0 md:pb-8 font-mulish"
      data-testid="position-page"
    >
      <div className="flex flex-row items-center py-6">
        <h1 className="font-bold text-xl mr-4">
          {t('EmployerDashboard.Positions')}
        </h1>
        <div className="h-1 w-full border-b border-solid border-b-employer-secondary" />
      </div>
      {position.filter((pos) => pos.Status !== 'Closed').length > 0 ? (
        <div
          className="grid grid-cols-1 md:grid-cols-2 gap-4"
          data-testid="position-card"
        >
          {position
            .filter((pos) => pos.Status !== 'Closed')
            .map((posit) => {
              return (
                <PositionCard key={`position-${posit.Id}`} position={posit} />
              );
            })}
        </div>
      ) : (
        <div className={classes.NoPositions} data-testid="position-card">
          <NoPosition />
          <h4 className={classes.NoPositionsTitle}>
            You have not added any position.
          </h4>
          <p className={classes.NoPositionsSubtitle}>
            Add as many position you need by clicking in the ”add new position”
            button.
          </p>
          <div
            style={{
              marginTop: '1.5rem',
            }}
          >
            <AddNewPositionButton />
          </div>
        </div>
      )}
    </div>
  );
};

export default PositionPage;
